import { render, staticRenderFns } from "./GameReport.vue?vue&type=template&id=5e482c29&scoped=true&"
import script from "./GameReport.vue?vue&type=script&lang=ts&"
export * from "./GameReport.vue?vue&type=script&lang=ts&"
import style0 from "./GameReport.vue?vue&type=style&index=0&id=5e482c29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e482c29",
  null
  
)

export default component.exports